module.exports = __webpack_public_path__ + "static/media/IMG-6.e92c7a5c.jpg";